export enum SynchronizationStatus {
    running = 'Running',
    failed = 'Failed',
    completed = 'Completed',
    canceled = 'Canceled',
    notSynchronized = 'NotSynchronized',
    unknown = 'Unknown',
}
